export const  Preloader = () => {
    return (
        <div className="row">
            <div className="col s5 yellow-information">
            <div className="row"></div>
            <div className="col s2">
                <div className="preloader-wrapper small active">
                    <div className="spinner-layer spinner-green-only">
                        <div className="circle-clipper left">
                        <div className="circle"></div>
                        </div><div className="gap-patch">
                            <div className="circle"></div>
                        </div><div className="circle-clipper right">
                            <div className="circle"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col s1"></div>
            <div className="col s2">
                <h5><b>Carregando...</b></h5>
            </div>
            <div className="row"></div>
            </div>
        </div>
    );
}